module.exports = __webpack_public_path__ + "img/dakong1.db253b4b.png";